document.addEventListener('Searchanise.Loaded', function () {
  (function ($) {

    // -------- helper: bind one collection safely (namespaced) ----------
    const bindTagRemovalForCollection = (namespace, tagsToRemove) => {
      const removeSnizeTagFilters = () => {
        const selectors = tagsToRemove.map(
          v => `#snize_filters_block_tags li:has(.snize-product-filters-checkbox[value="${v}"])`
        ).join(', ');
        $(selectors).remove();
      };

      // run once immediately (so tags don't flash)
      removeSnizeTagFilters();
      

      // bind safely (won't break other handlers)
      $(document)
        .off(`Searchanise.ResultsUpdated.${namespace}`)
        .on(`Searchanise.ResultsUpdated.${namespace}`, removeSnizeTagFilters);
    };

    // ✅ use pathname comparisons (exact match)
    const path = location.pathname;

    // ------------------ /collections/apparel ------------------
    if (path === '/collections/apparel') {
      bindTagRemovalForCollection('apparel', ["Mens", "Kids", "Womens", "Accessories"]);
    }

    // ------------------ /collections/snow ------------------
    if (path === '/collections/snow') {
      bindTagRemovalForCollection('snow', [
        "Mens",
        "Womens",
        "Camping Accessories",
        "Avalanche",
        "Snow & Ice",
        "Clearance",
        "Kids"
      ]);
    }

    // ----------- /collections/backpacking-camping -------------
    if (path === '/collections/backpacking-camping') {
      bindTagRemovalForCollection('backpackingCamping', [
        "Camping Accessories",
        "Avalanche",
        "Airbag",
        "Mens",
        "Womens",
        "Tents & Sleeping Bags",
        "TENTS & CANOPIES",
        "Kids",
        "Nordic",
        "Hiking & Backpacking",
        "Packs & Bags"
      ]);
    }

    // ------------------ /collections/climbing ------------------
    if (path === '/collections/climbing') {
      bindTagRemovalForCollection('climbing', [
        "Shelter & Sleep",
        "Mens",
        "Womens"
      ]);
    }

    // ------------------ /collections/footwear ------------------
    if (path === '/collections/footwear') {
      bindTagRemovalForCollection('footwear', [
        "Shelter & Sleep",
        "Sandals",
        "Clearance",
        "Footwear",
        "Mens",
        "Womens"
      ]);
    }

    // ------------------ /collections/womens ------------------
    if (path === '/collections/womens') {
      bindTagRemovalForCollection('womens', ["Mens", "Womens", "Jackets & Parkas", "Hiking Pants", "Apparel Accessories"]);
    }

    // ------------------ /collections/mens ------------------
    if (path === '/collections/mens') {
      bindTagRemovalForCollection('mens', ["Mens", "Womens", "Apparel Accessories"]);
    }

    // ------------------ /collections/watersports ------------------
    if (path === '/collections/watersports') {
      bindTagRemovalForCollection('watersports', ["Mens", "Womens"]);
    }

    // ✅ namespace must be simple (no space/apostrophe)
    if (path === '/collections/mens-jackets') {
      bindTagRemovalForCollection('mensJackets', ["Mens", "Womens"]);
    }

    if (path === '/collections/mens-bottoms') {
      bindTagRemovalForCollection('mensBottoms', ["Hiking Pants"]);
    }

    if (path === '/collections/mens-accessories') {
      bindTagRemovalForCollection('mensAccessories', ["Unisex"]);
    }

    // ✅ your URL had missing /collections/ in one place; also avoid dash in namespace
    if (path === '/collections/men-eyewear') {
      bindTagRemovalForCollection('menEyewear', ["Kids", "Mens", "Womens"]);
    }

    if (path === '/collections/womens-tops') {
      bindTagRemovalForCollection('womenstops', [ "Womens"]);
    }
if (path === '/collections/womens-bottoms') {
      bindTagRemovalForCollection('womensbottoms', [ "Mens", "Womens"]);
    }
    if (path === '/collections/womens-footwear') {
      bindTagRemovalForCollection('womensfootwear', [ "Sandals"]);
    }
   if (path === '/collections/downhill-skis') {
      bindTagRemovalForCollection('downhillskis', [ "Sandals"]);
    }
     if (path === '/collections/nordic') {
      bindTagRemovalForCollection('nordic', [ "Classic Nordic Ski",
"Rossignol classic ski",
"rossignol nordic ski"]);
    }
        if (path === '/collections/avalanche-equipment') {
      bindTagRemovalForCollection('avalancheequipment', [ "Classic Nordic Ski",
"Rossignol classic ski",
"rossignol nordic ski"]);
    }
      if (path === '/collections/packs') {
      bindTagRemovalForCollection('packs', [ "Packs & Bags"]);
    }
    if (path === '/collections/camping-accessory') {
      bindTagRemovalForCollection('campingaccessory', [ "Camping",
"Straps"]);
    }

     if (path === '/collections/garmin') {
      bindTagRemovalForCollection('garmin', [ "Light & Electronics"]);
    }


    if (path === '/collections/nordic-skis') {
      bindTagRemovalForCollection('nordicskis', [ "Skate XC",
"Classic"]);
    }
if (location.pathname.startsWith('/collections/')) {
  bindTagRemovalForCollection('globalTags', [
    "Mens",
    "Kids",
     "Midwinter",
    "Unisex",
    "Camp & Kitchen",
    "Sweat Shirts",
    "Womens"
  ]);
}


    // ------------------ jackets collections list ------------------
    const JACKET_COLLECTIONS = [
      '/collections/mens-jackets',
      '/collections/mens-insulated-synthetic-jackets',
      '/collections/mens-insulated-down-jackets',
      '/collections/mens-hardshell-jackets-1',
      '/collections/mens-softshell-jackets',
      '/collections/mens-fleece-jackets',
      '/collections/mens-snowsports-jackets',
      '/collections/mens-casual-jackets',

      '/collections/womens-jackets',
      '/collections/womens-insulated-synthetic-jackets',
      '/collections/womens-insulated-down-jackets',
      '/collections/womens-hardshell-jackets-1',
      '/collections/womens-softshell-jackets',
      '/collections/womens-fleece-jackets',
      '/collections/womens-snowsports-jackets',
      '/collections',
      '/collections/womens-casual-jackets'
    ];

    // ✅ use pathname exact match for list
    if (JACKET_COLLECTIONS.includes(path)) {
      bindTagRemovalForCollection('jacketsGroup', ["Mens", "Womens"]);
    }

  })(window.Searchanise && window.Searchanise.$ ? window.Searchanise.$ : window.jQuery);
});
